import { ENTER_KEY_CODE } from "apps/phone_verification/util/consts";

export const submitOnEnterKeyDown = ({ event, onSubmit, disabled }) => {
	if (disabled || event.keyCode !== ENTER_KEY_CODE) {
		return;
	}

	event.preventDefault();

	if (onSubmit) {
		onSubmit();
	}
};



// WEBPACK FOOTER //
// ./src/apps/phone_verification/util/helpers.js